<template>
  <v-container>
    <v-subheader>Export</v-subheader>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <div>
          <v-btn @click="load" color="primary" class="my-3">Load</v-btn>
        </div>
        <div>
          <download-csv
            :data="json_data"
            :name="csvDateString + '_' + obj.title + '.csv'"
            :fields="fields"
            :advancedOptions="advancedOptions"
          >
            <v-btn
              @click="exportItems"
              color="primary"
              class="my-3"
              :disabled="!canExport"
              >Export</v-btn
            >
          </download-csv>
        </div>
      </v-col>
      <v-col v-if="items" cols="12" sm="6" md="8">
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="10"
        ></v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import JsonCSV from "vue-json-csv";
import moment, { min } from "moment";

export default {
  components: {
    downloadCsv: JsonCSV,
  },
  props: {
    obj: Object,
  },
  data() {
    return {
      items: null,
      advancedOptions: {
        // quotes: true,
        // quoteChar: "="
      },
    };
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      candidates: (state) => state.candidates,
      clients: (state) => state.clients,
    }),

    headers() {
      return this.obj.title == "Candidates"
        ? [
            {
              text: "Name",
              align: "left",
              sortable: false,
              value: "name",
            },
          ]
        : [
            {
              text: "Invoice No",
              align: "left",
              sortable: false,
              value: "invoiceNo",
            },
            {
              text: "Name",
              align: "left",
              sortable: false,
              value: "client.name",
            },
          ];
    },
    canExport() {
      return this.items && this.items.length > 0;
    },
    fields() {
      if (this.obj.title == "Invoices") {
        return ["_id", "invoiceNo", "location"];
      } else if (this.obj.title == "Candidates") {
        return [
          "WORKER REF",
          "TITLE",
          "FIRST NAME",
          "MIDDLE NAME",
          "SURNAME",
          "GENDER",
          "DOB",
          "NATIONALITY",
          "DO1R",
          "STATUS",
          "PASSPORT NUMBER",
          "PASSPORT EXPIRY",
          "BIRTH CERTIFICATE NUMBER",
          "RIGHT TO WORK REFERENCE",
          "VISA NUMBER",
          "VISA EXPIRY",
          "NI NUMBER",
          "BANK NAME",
          "BANK ACCOUNT NAME",
          "BANK ACCOUNT NUMBER",
          "BANK SORT CODE",
          "ADDRESS 1",
          "ADDRESS 2",
          "TOWN/CITY",
          "COUNTY",
          "POSTCODE",
          "HOME PHONE",
          "MOBILE PHONE",
          "EMAIL",
          "NOK NAME",
          "NOK RELATIONSHIP",
          "NOK PHONE 1",
          "NOK PHONE 2",
          "JOB TYPE",
          "ROLE",
          "DAYS / NIGHTS",
          "OFFICE",
          "TYPE",
          "CONTRACT",
          "CONTRACT START",
          "PROVIDER",
          "LTD COMPANY NAME",
          "LTD COMPANY NUMBER",
          "INCORPORATION DATE",
          "ENGAGEMENT TYPE",
          "COMPANY ADDRESS 1",
          "COMPANY ADDRESS 2",
          "UMBRELLA NAME",
          "UMBRELLA REF",
          "REFERENCES",
          "CRB STATUS",
          "CRB NUMBER",
          "CRB EXPIRY",
          "LICENCE NUMBER",
          "LICENCE ISSUE",
          "LICENCE EXPIRY",
          "ADR NUMBER",
          "TACHO NUMBER",
          "TACHO EXPIRY",
          "DQC NUMBER",
          "DQC EXPIRY",
          "DVLA STATUS",
          "DVLA CHECK DATE",
          "DVLA NEXT CHECK",
          "DVLA CURRENT POINTS",
        ];
      } else {
        return ["_id", "name", "location"];
      }
    },
    csvDateString() {
      var date = moment();

      return `${date.format("DD-MM-YY")}`;
    },
    json_data() {
      return this.items ? this.items : [];
    },
  },
  methods: {
    ...mapActions({
      fetchCandidates: "candidates/fetchAll",
      fetchClients: "clients/fetchAll",
      fetchInvoices: "invoices/fetchAll",
    }),
    exportItems() {},
    load() {
      if (this.obj.title == "Candidates") {
        this.loadCandidates();
      } else if (this.obj.title == "Clients") {
        this.loadClients();
      } else if (this.obj.title == "Invoices") {
        this.loadInvoices();
      }
    },
    async loadCandidates() {
      var candidates = await this.fetchCandidates();
      this.items = candidates.map((c) => {
        const name = c.name.split(" ");
        var firstName = "";
        var lastName = "";
        var middleNames = "";
        if (name.length > 0) {
          firstName = name[0];
        }
        if (name.length > 1) {
          lastName = name[name.length - 1];
        }
        if (name.length > 2) {
          middleNames = name.slice(1, name.length - 1).join(" ");
        }
        var dob;
        if (c.dob) {
          dob = moment(c.dob).format("YYYY-MM-DD");
        }

        var mobilePhone;
        var email;
        if (c.contacts && c.contacts.length > 0) {
          var contact = c.contacts.find((c) => c.type == "Phone");
          if (contact) mobilePhone = contact.value;

          var contact = c.contacts.find((c) => c.type == "Email");
          if (contact) email = contact.value;
        }

        return {
          name: c.name,
          "WORKER REF": c._id,
          TITLE: c.title,
          "FIRST NAME": firstName,
          "MIDDLE NAME": middleNames,
          SURNAME: lastName,
          GENDER: "",
          DOB: dob,
          NATIONALITY: "",
          DO1R: "",
          STATUS: "",
          "PASSPORT NUMBER": "",
          "PASSPORT EXPIRY": "",
          "BIRTH CERTIFICATE NUMBER": "",
          "RIGHT TO WORK REFERENCE": "",
          "VISA NUMBER": "",
          "VISA EXPIRY": "",
          "NI NUMBER": c.nationalInsuranceNo,
          "BANK NAME": "",
          "BANK ACCOUNT NAME": c.accountNAME,
          "BANK ACCOUNT NUMBER": c.accountNO,
          "BANK SORT CODE": c.sortCode,
          "ADDRESS 1": c.address && c.address.address,
          "ADDRESS 2": "",
          "TOWN/CITY": c.address && c.address.city,
          COUNTY: "",
          POSTCODE: c.address && c.address.postcode,
          "HOME PHONE": "",
          "MOBILE PHONE": mobilePhone,
          EMAIL: email,
          "NOK NAME": "",
          "NOK RELATIONSHIP": "",
          "NOK PHONE 1": "",
          "NOK PHONE 2": "",
          "JOB TYPE": "",
          ROLE: "",
          "DAYS / NIGHTS": "",
          OFFICE: "",
          TYPE: "",
          CONTRACT: "",
          "CONTRACT START": "",
          PROVIDER: "",
          "LTD COMPANY NAME": "",
          "LTD COMPANY NUMBER": "",
          "INCORPORATION DATE": "",
          "ENGAGEMENT TYPE": "",
          "COMPANY ADDRESS 1": "",
          "COMPANY ADDRESS 2": "",
          "UMBRELLA NAME": "",
          "UMBRELLA REF": "",
          REFERENCES: "",
          "CRB STATUS": "",
          "CRB NUMBER": "",
          "CRB EXPIRY": "",
          "LICENCE NUMBER": "",
          "LICENCE ISSUE": "",
          "LICENCE EXPIRY": "",
          "ADR NUMBER": "",
          "TACHO NUMBER": "",
          "TACHO EXPIRY": "",
          "DQC NUMBER": "",
          "DQC EXPIRY": "",
          "DVLA STATUS": "",
          "DVLA CHECK DATE": "",
          "DVLA NEXT CHECK": "",
          "DVLA CURRENT POINTS": "",
        };
      });
      console.log(this.items, "items");
    },
    async loadClients() {
      var clients = await this.fetchClients();
      this.items = clients;
    },
    async loadInvoices() {
      var clients = await this.fetchInvoices();
      this.items = clients;
    },
  },
};
</script>


